import { Container, Row, Col, Card } from "react-bootstrap";

export default function Buildings() {
  return (
    <Container fluid className="py-5 bg-white">
      <h2 className="text-center text-primary fw-bold">Buildings</h2>
      <p className="mt-3 text-center text-secondary fs-5">
        Delivering high-quality commercial, residential, and institutional buildings with innovative designs.
      </p>

      <Row className="mt-4 justify-content-center g-4">
        <Col xs={12} md={6} lg={4} className="d-flex justify-content-center">
          <Card className="shadow border-0" style={{padding: "5px" }}>
            <Card.Body>
              <Card.Title className="text-primary fw-bold">Commercial Spaces</Card.Title>
              <Card.Text className="text-secondary">
                Developing office buildings, malls, and business hubs.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>

        <Col xs={12} md={6} lg={4} className="d-flex justify-content-center">
          <Card className="shadow border-0" style={{padding: "5px" }}>
            <Card.Body>
              <Card.Title className="text-primary fw-bold">Housing Projects</Card.Title>
              <Card.Text className="text-secondary">
                Building modern residential complexes with world-class amenities.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
